import { useFetch } from "~vue/api";
import type { RecordUiInteractionRequest, UiInteractionType } from "~vue/api/generated/ui-interactions";

export function useUIInteractions() {
    /**
     * Records the interaction, returning whether it actually reached the server.
     *
     * useFetch executes with `throwOnFailed = false`, so awaiting the POST resolves even on a 500
     * or a dropped connection — callers that must not proceed without a durable record have to
     * check the result rather than the absence of a rejection.
     */
    const createInteraction = async (interactionType: UiInteractionType): Promise<boolean> => {
        const payload: RecordUiInteractionRequest = { interaction_type: interactionType };
        // Re-executing a shared fetch aborts the previous write.
        const { execute: executePost, error } = useFetch("/api/accounts/ui-interactions", { immediate: false }).post(payload).json();
        await executePost();
        return !error.value;
    };

    const fetchInteractions = (interactionType: UiInteractionType) => {
        const params = new URLSearchParams({ interaction_type: interactionType });
        return useFetch(`/api/accounts/ui-interactions?${params}`).json<{ interactions: { interaction_type: UiInteractionType }[] }>();
    };

    return {
        createInteraction,
        fetchInteractions,
    };
}
